import { useTranslation } from "react-i18next";
import type { DealerDeviceTransferNotification } from "@/gql/graphql";
import DataListItemText from "./DataListItemText";

type DeviceTransferRequestExpiredNotificationProps = {
  data: Pick<DealerDeviceTransferNotification, "model" | "serialNumber">;
};

const DeviceTransferRequestExpiredNotification = (
  props: DeviceTransferRequestExpiredNotificationProps
) => {
  const { data } = props;
  const { model, serialNumber } = data;
  const { t } = useTranslation();

  return (
    <DataListItemText
      primary={t("notifications.device_transfer_request_expired.title")}
      secondary={t(
        "notifications.device_transfer_request_expired.description",
        { model: model ?? "", serialNumber }
      )}
    />
  );
};

export default DeviceTransferRequestExpiredNotification;
